import { DEFAULT_ROUTES } from '@insight2profit/drive-app';

export const ROUTES = {
    ...DEFAULT_ROUTES,
    analytics: '/analytics',
} as const;
